export default class WsPickController {
    ngModel: any;

    flush: any;

    originFn: any[] = [];

    targetFn: any[] = [];

    originData: any = [];

    targetData: any = [];

    checkOrigin: any[] = [];

    checkTarget: any[] = [];

    model: any;

    constructor() {}

    setModel(model: any) {
        this.model = model;
    }

    setNgModel(ngModel: any) {
        this.ngModel = ngModel;
    }

    convert(data: any[]): any[] {
        const model = this.model;
        return data.map((item) => {
            return {
                value: model.value({ [model.model]: item }),
                view: model.view({ [model.model]: item }),
                origin: item
            };
        });
    }

    registerFlush(fn: any) {
        this.flush = fn;
    }

    setCheckOrigin(data: any) {
        this.checkOrigin = data;
    }

    setCheckTarget(data: any) {
        this.checkTarget = data;
    }

    trigger(direction: string) {
        let viewValue = this.ngModel.$viewValue || [];
        if (direction === "right") {
            viewValue = viewValue.concat(this.checkOrigin);
        }
        if (direction === "left") {
            viewValue = viewValue.filter((item) => {
                return (
                    this.checkTarget.find((iitem) => {
                        return this.objectEqual(iitem, item);
                    }) === undefined
                );
            });
        }
        this.ngModel.$setViewValue(viewValue);
        this.flush(viewValue);
    }

    changeOrigin(data: any) {
        this.originData = data;
        this.originFn.forEach((item) => {
            item(data);
        });
    }

    changeTarget(data: any) {
        this.targetData = data;
        this.targetFn.forEach((item) => {
            item(data);
        });
    }

    listenOriginChange(fn) {
        this.originFn.push(fn);
        fn(this.originData);
    }

    listenTargetChange(fn) {
        this.targetFn.push(fn);
        fn(this.targetData);
    }

    objectEqual(o1, o2) {
        if (typeof o1 !== typeof o2) return false;
        if (angular.isArray(o1) || angular.isObject(o1)) {
            return angular.equals(JSON.parse(angular.toJson(o1)), JSON.parse(angular.toJson(o2)));
        } else {
            return o1 === o2;
        }
    }
}
